export const CHECKLIST = {
  "Checklist.Success.Color": {
    ref: "Color.Secondary.One.500"
  },
  "Checklist.Close.Icon.Color": {
    ref: "Color.Icon.Dark.Gray"
  },
  "Checklist.Readonly.Completed.Border.Color": {
    ref: "Color.Transparent"
  }
};
